import Car from "@gaiaProfessionals/Icons/Car";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => {
    const cartState = getCurrentCartState(state);
    return {
        billToState: getBillToState(state, cartState.value ? cartState.value.billToId : undefined),
    };
};

export interface GAIAProductDetailsFreeShippingMessageStyles {
    wrapper?: InjectableCss;
    icon?: IconPresentationProps;
    text?: TypographyPresentationProps;
}

export const styles: GAIAProductDetailsFreeShippingMessageStyles = {
    wrapper: {
        css: css`
            margin: 15px 0px;
            width: 100%;
            display: flex;
        `,
    },
    icon: {
        css: css`
            margin-top: 3px;
            margin-right: 5px;
            fill: ${getColor("primary")};
        `,
    },
    text: {
        color: "text.main",
        css: css`
            font-size: 13px;
            font-family: "Lato";
        `,
    },
};

const GAIAProductDetailsFreeShippingMessage: React.FC<OwnProps> = ({ product, billToState }) => {
    const freeShippingThreshold = billToState?.value?.properties.freeShippingThreshold
        ? parseFloat(billToState?.value?.properties.freeShippingThreshold)
        : 0;
    if (!freeShippingThreshold) {
        return null;
    }
    const shippingThresholdMessage =
        freeShippingThreshold > 0
            ? siteMessage("ProductDetail_FreeShippingMessage", `${freeShippingThreshold}`)
            : undefined;
    return (
        <StyledWrapper {...styles.wrapper}>
            <Icon src={Car} {...styles.icon} />
            <Typography {...styles.text}>{shippingThresholdMessage}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(GAIAProductDetailsFreeShippingMessage)),
    definition: {
        displayName: "Free Shipping Message",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
